/** Tab identifiers for the chart panel. */
export enum ChartPanelTabId {
  ElationAi = 'elation-ai',
  ChronologicalRecord = 'chronological-record',
}

/** Type guard for {@link ChartPanelTabId}. */
export function isChartPanelTabId(value: unknown): value is ChartPanelTabId {
  return value === ChartPanelTabId.ElationAi || value === ChartPanelTabId.ChronologicalRecord;
}

const HIDDEN_CLASS = 'el8-tab-hidden';

const CHART_FEED_ID = 'chart-feed-container';
const MAGIC_PANEL_ID = 'react-chart-assist-magic-panel-container';
const MANAGED_IDS = [CHART_FEED_ID, MAGIC_PANEL_ID];

/**
 * Toggle visibility of legacy DOM elements based on the active tab.
 */
export function applyTabVisibility(activeTab: ChartPanelTabId): void {
  document
    .getElementById(CHART_FEED_ID)
    ?.classList.toggle(HIDDEN_CLASS, activeTab === ChartPanelTabId.ElationAi);
  document
    .getElementById(MAGIC_PANEL_ID)
    ?.classList.toggle(HIDDEN_CLASS, activeTab === ChartPanelTabId.ChronologicalRecord);
}

/** Remove all tab-visibility classes (cleanup on unmount). */
export function clearTabVisibility(): void {
  for (const id of MANAGED_IDS) {
    document.getElementById(id)?.classList.remove(HIDDEN_CLASS);
  }
}
